import { useEffect, useState } from 'react'

/**
 * Tracks the iOS virtual keyboard height using the visualViewport API.
 * Returns the keyboard height in pixels (0 when keyboard is hidden).
 * Use this to push content above the keyboard in modals/sheets.
 */
export function useKeyboardAvoidance(): number {
  const [keyboardHeight, setKeyboardHeight] = useState(0)

  useEffect(() => {
    if (!window.visualViewport) return

    const handler = () => {
      const viewport = window.visualViewport!
      const hidden = window.innerHeight - viewport.height - viewport.offsetTop
      setKeyboardHeight(Math.max(0, hidden))
    }

    window.visualViewport.addEventListener('resize', handler)
    window.visualViewport.addEventListener('scroll', handler)
    return () => {
      window.visualViewport?.removeEventListener('resize', handler)
      window.visualViewport?.removeEventListener('scroll', handler)
    }
  }, [])

  return keyboardHeight
}
